// src/app/core/services/signature-size.service.ts
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { HttpClientBase } from './http-client-base.service';

@Injectable({ providedIn: 'root' })
export class UanatacaIdentificadorService extends HttpClientBase {
  constructor(http: HttpClient) {
    super(http, 'uanataca/identificadores'); // o '/signature-size'
  }

  /** GET /signature-size */
  getAll(trackLoading = true): Observable<any[]> {
    return this.get<any[]>({ trackLoading }).pipe(
      map((resp) => resp.body ?? []),
    );
  }

}